module.exports = __webpack_public_path__ + "static/media/lo5d_post_C.e8ffc46b.svg";